import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import AboutSection from '../../components/AboutSection';
import {FaLightbulb} from 'react-icons/fa';
import {BsBinocularsFill} from 'react-icons/bs';
import WhyUs from '../../components/WhyUs';
import Testimonial from '../../components/Testimonial';
import './about.css';

const About = () => {

    return (
        <m.div
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="About" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / About Us
                </p>
            </PageHeader>
            <section className='about'>
                <div className="container about_container">
                    <AboutSection />
                    <div className="container about about-pestex">
                        <div className="about-content">
                            <h1>About PestEx Masters</h1>
                            <p>
                                Our team of experienced pest control experts is trained to identify, treat, and prevent infestations using
                                the latest techniques and technologies. We use eco-friendly and safe pest control products that are
                                effective in eradicating pests without causing harm to your environment or your health. Our services are
                                tailored to meet your specific needs and budget, whether you require a one-time treatment or ongoing
                                maintenance programs.
                            </p>
                            <p>
                                At PestEX Masters, we believe in delivering exceptional customer service. We work closely
                                with our clients to ensure that we understand their pest control needs and provide them with
                                personalized solutions that address their unique challenges. We are committed to responding to your
                                requests promptly and professionally, and we are always available to answer your questions and provide
                                you with expert advice.
                            </p>
                            <p>
                                We take pride in our reputation for quality pest control services, and we are dedicated to maintaining
                                our high standards. We are fully licensed and insured, and our team undergoes regular training to stay
                                up to date with the latest industry standards and practices. We also adhere to strict safety protocols to
                                ensure that our services are safe for you, your family, and your pets.
                            </p>
                        </div>
                    </div>

                    <div className="values">
                        <div className="value_detail_one">
                            <h4>OUR VALUES</h4>
                            <h2>Guaranteed pest removal with no hassle for you.</h2>
                            <p>
                                We take pride in our reputation for quality pest control services, and we are dedicated to maintaining
                                our high standards. We are fully licensed and insured, and our team undergoes regular training to stay
                                up to date with the latest industry standards and practices.
                            </p>
                        </div>
                        <div className="value_detail_two">
                            <div className="value misson">
                                <FaLightbulb className='values_icon'/>
                                <div className="value_details">
                                    <h4>MISSION</h4>
                                    <p>
                                        At PestEX Masters, our mission is to provide exceptional pest control services with a focus on customer
                                        satisfaction and environmental responsibility. We are committed to safeguarding homes, businesses,
                                        and communities from the nuisance and health risks associated with pests. Through our expertise,
                                        cutting-edge techniques, and eco-friendly solutions, we aim to create pest-free environments that
                                        promote peace of mind and enhance the quality of life for our clients. With a dedicated team of highly
                                        skilled professionals, we strive to exceed expectations, delivering efficient and reliable pest control
                                        services tailored to meet the unique needs of each client. Your satisfaction and a pest-free environment
                                        are our top priorities at PestEX Masters.
                                    </p>
                                </div>
                            </div>
                            <div className="value vission">
                                <BsBinocularsFill className='values_icon'/>
                                <div className="value_details">
                                    <h4>VISION</h4>
                                    <p>
                                        At PestEX Masters, our vision is to create pest-free environments for our clients, promoting healthier
                                        and happier communities. With our comprehensive pest control services, we aim to be the leading
                                        provider in the industry, offering innovative solutions that prioritize sustainability and customer
                                        satisfaction. Through our expertise, professionalism, and commitment to excellence, we strive to exceed
                                        expectations and ensure a pest-free future for all. Trust PestEX Masters for reliable, efficient, and
                                        effective pest management solutions that safeguard your peace of mind.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <WhyUs />
                    <Testimonial />
                </div>
            </section>
        </m.div>
    )
}

export default About